import { ClaimRewardsProps } from '@/presentation/context/modal/ModalContext';
import Modal from '../modules/Modal';
import ClaimRewards from '../views/ClaimRewards';

const ClaimRewardsModal = (props: ClaimRewardsProps) => {
  return (
    <Modal size="lg" clickOffToClose>
      <div className="py-4 px-6 bg-gray-50">
        <ClaimRewards {...props} />
      </div>
    </Modal>
  );
};

export default ClaimRewardsModal;
